<template>
  <div class="about-section">
    <div class="row">
      <div class="col-6 text-center">
        <img 
          src="../../assets/img/que es Talentinus.png" 
          alt="About Us" 
          class="about-image"
        />
      </div>
      <div class="col-6">
        <h1 class="title-second">¿Qué es Talentinus?</h1>
        <p class="description">
          Talentinus es una guía moderna para padres que quieren entender mejor a sus hijos y acompañarlos con claridad, sin imponer caminos en su elección de carrera universitaria.
        </p>
        <p class="description">
          No es solo un test. Es un sistema de diagnóstico vocacional y emocional que revela cómo es tu hijo, qué lo motiva, en qué tipo de entornos puede florecer y qué decisiones tienen más sentido para él o ella en este momento de su vida.
        </p>
        <p class="description">
          Es el inicio de una conversación transformadora.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutSection'
}
</script>

<style scoped>
.about-section {
  width: 100%;
  padding: 32px 16px;
  box-sizing: border-box;
}

.row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
}

.col-6 {
  flex: 1 1 0;
  max-width: 50%;
  box-sizing: border-box;
}

.about-image {
  width: 100%;
  max-width: 400px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.title-second {
  font-size: 2rem;
  margin-bottom: 18px;
}

.description {
  font-size: 1.1rem;
  margin-bottom: 12px;
}

@media (max-width: 768px) {
  .about-section {
    padding: 18px 4vw !important;
  }
  .row {
    flex-direction: column !important;
    gap: 12px !important;
    align-items: center !important;
  }
  .col-6 {
    max-width: 100% !important;
    width: 100% !important;
    text-align: center !important;
    padding: 0 !important;
  }
  .about-image {
    max-width: 90vw !important;
    margin-bottom: 12px;
  }
  .title-second {
    font-size: 22px !important;
    margin-bottom: 12px !important;
  }
  .description {
    font-size: 15px !important;
    padding: 0 4px !important;
    margin-bottom: 10px !important;
  }
  .about-section,
  .row,
  .col-6 {
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    overflow: visible !important;
    display: block !important;
  }
}
</style>

